import { createSlice } from "@reduxjs/toolkit"

import ct from "@constants/"
import { queryClient } from "@lib/query-client.js"

export const authSlice = createSlice({
  name: ct.store.USER_STORE,
  initialState: {
    userName: "",
    displayName: "",
    email: "",
    photoURL: "",
    isAuthenticated: false,
    userRole: "",
    uid: "",
  },
  reducers: {
    login: (state, action) => {
      state.userName = action.payload.userName
      state.displayName = action.payload.displayName
      state.email = action.payload.email
      state.photoURL = action.payload.photoURL
      state.isAuthenticated = true
      state.userRole = action.payload.userRole
      state.uid = action.payload.uid
    },
    logout: (state) => {
      state.userName = ""
      state.displayName = ""
      state.email = ""
      state.photoURL = ""
      state.isAuthenticated = false
      state.userRole = ""
      state.uid = ""
      queryClient.clear()
    },
  },
})

export const { login, logout } = authSlice.actions

export default authSlice.reducer
